<template>
	<div class="container audit-card mx-auto">
		<div class="row pr-3">
			<div class="col-8 my-auto text-left" v-bind:class="!larger ? 'col-md-12 col-lg-8' : ''">
				<span class="w-100 font-weight-bold">{{venue_name}}</span>
				<div class="w-100 audit-card--who-when">
					<span>{{user.first_name + ' ' + user.last_name}}</span> <span>{{created_at}}</span>
				</div>
			</div>
			<div class="col-1 col-lg-1 col-xl-2 my-auto" v-bind:class="!larger ? 'order-0 order-md-1 order-lg-0' : ''">
				<i v-if="improved === true"><img src="@/images/up.svg" /></i>
				<i v-else-if="improved === false"><img src="@/images/down.svg" /></i>
				<i v-else> - </i>
			</div>
			<div class="col-1 col-lg-1 col-xl-2 my-auto audit-card--score" v-bind:class="!larger ? 'order-1 order-md-0 order-lg-1 col-md-3' : ''">
				<h4 v-if="total_score < 70" class="text-pale-yellow">{{total_score}}</h4>
				<h4 v-else-if="total_score < 80" class="text-yellow">{{total_score}}</h4>
				<h4 v-else class="">{{total_score}}</h4>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props:[
			'venue_name', 'total_score', 'improved', 'user', 'created_at', 'larger'
		],

		watch: {
			venue(){

			}
		}
	}
</script>
